import * as React from 'react'

import { Box, Card } from '@factorialco/deprecated-design-system'

import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

interface Props {
  leaveTypeForm: LeaveTypeFormModel
}

const DaysUnitsInput = ({ leaveTypeForm }: Props) => {
  const maxDaysInCentsLabel = i18n.t(
    'settings.leave_types.page.duration.form.days_unit.max_days_in_cents.label'
  )
  const minDaysInCentsLabel = i18n.t(
    'settings.leave_types.page.duration.form.days_unit.min_days_in_cents.label'
  )

  const maxDayField = leaveTypeForm.get('max_days_in_cents')

  return (
    <Box gap="s24" minWidth="full">
      <Text
        field={leaveTypeForm.get('min_days_in_cents')}
        label={minDaysInCentsLabel}
        placeholder={i18n.t('common.unlimited_days')}
        onChange={() => leaveTypeForm.get('min_days_in_cents').setErrors(null)}
      />
      <Text
        field={maxDayField}
        label={maxDaysInCentsLabel}
        placeholder={i18n.t('common.unlimited_days')}
        onChange={() => maxDayField.setErrors(null)}
      />
    </Box>
  )
}

const DaysUnits = ({ leaveTypeForm }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-days-units-input' }}>
    <Card.Title size="small">
      {i18n.t('settings.leave_types.page.duration.form.days_unit.label')}
    </Card.Title>
    <Card.Description>
      {i18n.t('settings.leave_types.page.duration.form.days_unit.description')}
    </Card.Description>
    <Card.Content>
      <DaysUnitsInput leaveTypeForm={leaveTypeForm} />
    </Card.Content>
  </Card>
)

export default DaysUnits
